module.exports = __webpack_public_path__ + "img/dent.282341ce.jpg";